import { Component } from '@angular/core';

@Component({
  selector: 'app-main',
  template: '',
})
export class MainComponent {}
